import ModalManager from "@/components/ModalComponent/ModalManager";
import React from "react";
import { APActivity } from "../../../ActivityInterfaces";
import {
  VacancyApplicant,
  VacancyApplication,
} from "../model/VacancyApplicant.interface";
import { APOffer } from "../../../views/details/offer-feature/APOffer.Interface";
import VacancyApplicantDetailedComponent from "../vacancy-applicant/components/vacancy-applicant-entry/VacancyApplicantDetailedComponent";
import { ActivityApplicationConstants } from "../../../ActivityHooks";
import i18n from "@/i18n";

const useVacancyApplicantDetails = () => {
  const openApplicantDetailsModal = (params: {
    offer?: APOffer;
    activity: APActivity;
    constants: ActivityApplicationConstants;
    application: VacancyApplication;
    applicant: VacancyApplicant;
    renderGuarantor?: boolean;
    editable?: boolean;
    onOpenGuarantorModal?: () => void;
  }) => {
    const {
      offer,
      activity,
      constants,
      application,
      applicant,
      renderGuarantor,
      editable,
      onOpenGuarantorModal,
    } = params;

    const title = renderGuarantor
      ? i18n.t(
          "apTemplate:Vacancy.Applicant.DetailsModal.TitleGuarantor",
          "Details des Bürgen"
        )
      : i18n.t(
          "apTemplate:Vacancy.Applicant.DetailsModal.Title",
          "Mietinteressenten"
        );
    ModalManager.show({
      title,
      headerCloseButton: true,
      content: (
        _states: any,
        _setStates: (states: any) => void,
        closeModal?: () => void
      ) => (
        <VacancyApplicantDetailedComponent
          application={application}
          applicant={applicant}
          constants={constants}
          activity={activity}
          offer={offer}
          renderGuarantor={renderGuarantor}
          editable={editable}
          closeModal={closeModal}
          onOpenGuarantorModal={onOpenGuarantorModal}
        />
      ),
      buttons: [
        {
          text: i18n.t("Globals.Buttons.Close", "Schließen"),
          closeOnClick: true,
          appearance: "primary",
        },
      ],
      size: "fluid",
    });
  };

  return { openApplicantDetailsModal };
};

export default useVacancyApplicantDetails;
